import { bl_inv_bin_lock_RowClass, bl_inv_bin_lock_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class BinLockContainer extends BaseContainerModel {
  bl_inv_bin_lock: bl_inv_bin_lock_RowInterface = new bl_inv_bin_lock_RowClass();
}
